import { OnboardingSessionContext } from './context';
import { useContext } from 'react';

export const useOnboardingSession = () => {
  const context = useContext(OnboardingSessionContext);

  if (!context) {
    throw new Error('useOnboardingSession must be used within OnboardingSessionProvider');
  }

  return context;
};